<template>
  <el-button v-bind="options" @click="clickFn">{{ text }}</el-button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    clickFn: {
      type: Function,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
</style>
